import PropTypes from 'prop-types'
import { Button } from 'react-bootstrap'
import styles from './inputConTextoSugerencia.module.css'

export const InputConTextoSugerencia = ({
  texto,
  codigo,
  value,
  copiar,
  setSugerencias,
  arrayChance,
  sugerencias,
  categoria,
  handleSelectSugerencias,
  handleChange,
  modificarCarrito,
  idPublicacion
}) => {
  return (
    <div
      className={`mb-2 mt-1 mb-md-0 me-2 ${styles.posicionRelative} ${styles.marginBottom} ${styles.gapBloque} `}
    >
      <div style={{ display: 'flex' }}>
        <label htmlFor={codigo} className={styles.divImputacionesLabel}>
          {texto}
        </label>
        {handleChange ? (
          <input
            id={categoria}
            type="text"
            value={value}
            onChange={(e) =>
              handleChange(e.target.value, categoria, setSugerencias, arrayChance, idPublicacion)
            }
            className={styles.formControl}
          />
        ) : (
          <select
            className="form-select"
            style={{
              minWidth: '120px',
              borderTopRightRadius: 0,
              borderBottomRightRadius: 0
            }}
            value={value}
            onChange={(e) => {
              const selectedOption = e.target.options[e.target.selectedIndex]

              modificarCarrito(e.target.value, categoria, idPublicacion, selectedOption.text)
            }}
          >
            <option value="">---</option>
            {arrayChance &&
              arrayChance?.map((opcion) => (
                <option key={opcion.value} value={opcion.value}>
                  {opcion.label}
                </option>
              ))}
          </select>
        )}
        {copiar && (
          <Button
            onClick={() => copiar(categoria, value)}
            variant="light"
            style={{ borderTopLeftRadius: 0, borderBottomLeftRadius: 0 }}
          >
            <i className="bi bi-clipboard"></i>
          </Button>
        )}
      </div>
      {sugerencias && sugerencias.length > 0 && (
        <ul className={styles.sugerenciasList}>
          {sugerencias.map((p, i) => (
            <li key={p.codigo + i} onClick={() => handleSelectSugerencias(p, categoria)}>
              {p.codigo} - {p.descripcion}
            </li>
          ))}
        </ul>
      )}
    </div>
  )
}

InputConTextoSugerencia.propTypes = {
  texto: PropTypes.string.isRequired,
  codigo: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  copiar: PropTypes.func.isRequired,
  setSugerencias: PropTypes.func.isRequired,
  arrayChance: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      label: PropTypes.string
    })
  ),
  sugerencias: PropTypes.arrayOf(
    PropTypes.shape({
      codigo: PropTypes.string,
      descripcion: PropTypes.string
    })
  ),
  categoria: PropTypes.string.isRequired,
  handleSelectSugerencias: PropTypes.func.isRequired,
  handleChange: PropTypes.func,
  modificarCarrito: PropTypes.func,
  idPublicacion: PropTypes.number
}
